import { faArrowLeft, faArrowRight } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../TwinIcon'
import { useNavigate } from 'react-router';

interface NavigateArrowsProps {}

const NavigateArrows: React.FC<NavigateArrowsProps> = () => {
    const navigate = useNavigate();
    return (
        <div className='flex items-center border-r border-gray-C7 mr-10 navigate_arrows'>
            <div className='border border-gray-C7 flex cursor-pointer'>
                <TwinIcon icon={faArrowLeft} className='text-gray-3E  py-5 px-8' fontSize={17} onClick={() => navigate(-1)}></TwinIcon>
            </div>
            <div className='border border-gray-C7 ml-15 mr-15 flex cursor-pointer'>
                <TwinIcon icon={faArrowRight} className='text-gray-3E py-5 px-8' fontSize={17} onClick={() => navigate(1)}></TwinIcon>
            </div>
        </div>
    )
}

export default NavigateArrows